import React, { PureComponent } from 'react'

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position:  200% center; }
  }
  @keyframes fadeSlideUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes orbPulse1 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.45; }
    50%     { transform: scale(1.1) translate(20px,-15px); opacity:.65; }
  }
  @keyframes orbPulse2 {
    0%,100% { transform: scale(1) translate(0,0); opacity:.35; }
    50%     { transform: scale(1.07) translate(-20px,15px); opacity:.55; }
  }
  @keyframes particle {
    0%   { transform: translateY(0) translateX(0); opacity:0; }
    10%  { opacity:.8; }
    90%  { opacity:.3; }
    100% { transform: translateY(-110vh) translateX(var(--dx)); opacity:0; }
  }
  .mi-particle {
    position: fixed;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(0,220,210,.8) 0%, rgba(0,160,190,.3) 60%, transparent 100%);
    animation: particle var(--dur) var(--delay) ease-in infinite;
    pointer-events: none;
    z-index: 0;
  }
  .mi-page {
    font-family: 'DM Sans', sans-serif;
    min-height: 100vh;
    background: linear-gradient(145deg,#04111a 0%,#091e2e 35%,#0d2840 60%,#06141e 100%);
    position: relative;
    overflow-x: hidden;
    color: #e8f4f6;
  }
  .mi-grid-bg {
    position: fixed;
    inset: 0;
    pointer-events: none;
    background-image:
      linear-gradient(rgba(0,210,200,.025) 1px, transparent 1px),
      linear-gradient(90deg, rgba(0,210,200,.025) 1px, transparent 1px);
    background-size: 55px 55px;
    z-index: 0;
  }
  .mi-content {
    position: relative;
    z-index: 1;
    padding: 12px 12px 24px;
  }
  .mi-breadcrumb {
    padding: 10px 16px;
    font-size: 13px;
    background: rgba(0,0,0,.25);
    border-bottom: 1px solid rgba(0,210,200,.12);
    backdrop-filter: blur(8px);
    position: sticky;
    top: 0;
    z-index: 10;
    animation: fadeSlideUp .4s ease both;
  }
  .mi-breadcrumb-current { color: #7ab0b8; font-weight: 600; }
  .mi-section {
    border: 1px solid rgba(0,210,200,.18);
    margin-bottom: 8px;
    border-radius: 12px;
    overflow: hidden;
    background: linear-gradient(160deg, rgba(12,28,45,.96) 0%, rgba(7,18,32,.98) 100%);
    box-shadow: 0 4px 24px rgba(0,0,0,.5), 0 0 40px rgba(0,150,160,.05), inset 0 1px 0 rgba(0,210,200,.07);
    backdrop-filter: blur(12px);
  }
  .mi-shimmer-line {
    height: 2px;
    background: linear-gradient(90deg, transparent, #00d2c8, #48cae4, #00d2c8, transparent);
    background-size: 200% auto;
  }
  .mi-section-header {
    background: linear-gradient(90deg, rgba(0,160,155,.28) 0%, rgba(0,120,175,.18) 100%);
    border-bottom: 1px solid rgba(0,210,200,.15);
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    transition: background .2s;
  }
  .mi-section-header:hover {
    background: linear-gradient(90deg, rgba(0,160,155,.38) 0%, rgba(0,120,175,.28) 100%);
  }
  .mi-section-title {
    font-size: 13px;
    font-weight: 700;
    color: #e8f4f6;
    letter-spacing: .03em;
  }
  .mi-toggle-btn {
    width: 22px; height: 22px;
    border-radius: 6px;
    background: rgba(0,210,200,.15);
    border: 1px solid rgba(0,210,200,.3);
    color: #00d2c8;
    font-size: 15px;
    font-weight: 700;
    display: flex; align-items: center; justify-content: center;
    transition: all .2s;
    flex-shrink: 0;
  }
  .mi-section-header:hover .mi-toggle-btn {
    background: rgba(0,210,200,.25);
    box-shadow: 0 0 10px rgba(0,210,200,0.3);
  }

  /* ── Section body: background UNCHANGED (#c5d7d5), only text/input colors fixed ── */
  .mi-section-body {
    padding: 14px 16px;
    background: #c5d7d5;
  }

  .mi-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
  }
  .mi-field { display: flex; flex-direction: column; min-width: 60px; }

  /* Labels — dark teal, clearly visible on mint background */
  .mi-label {
    font-size: 10.5px;
    color: #1a5558;
    margin-bottom: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: .02em;
    font-weight: 600;
  }

  .mi-input-wrap { display: flex; align-items: center; gap: 5px; }

  /* Inputs — semi-transparent white so the mint shows through, dark text */
  .mi-input {
    width: 100%;
    padding: 5px 9px;
    border: 1px solid rgba(0,100,95,.28);
    border-radius: 7px;
    font-size: 12px;
    height: 28px;
    box-sizing: border-box;
    background: rgba(255,255,255,.52);
    color: #0b2d30;
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    transition: border-color .2s, box-shadow .2s, background .2s;
    outline: none;
  }
  .mi-input:focus {
    border-color: #007a74;
    box-shadow: 0 0 0 3px rgba(0,120,115,.2);
    background: rgba(255,255,255,.72);
    color: #051c20;
  }
  .mi-input:hover:not(:focus) {
    border-color: rgba(0,100,95,.48);
    background: rgba(255,255,255,.62);
  }
  select.mi-input { cursor: pointer; color: #0b2d30; }
  select.mi-input option { background: #ddecea; color: #0b2d30; }

  /* Verified checkmark */
  .mi-check {
    color: #006f6a;
    font-weight: 700;
    font-size: 14px;
    filter: drop-shadow(0 0 3px rgba(0,140,130,.4));
    flex-shrink: 0;
  }
  .mi-input::placeholder { color: rgba(10,55,58,.38); }

  /* Leave / attendance badges */
  .mi-leave-badge {
    display: inline-flex;
    align-items: center;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 11px;
    font-weight: 600;
    color: #094a47;
    background: rgba(0,120,110,.13);
    border: 1px solid rgba(0,120,110,.28);
  }

  .mi-attendance-stats {
    display: flex;
    gap: 16px;
    margin-bottom: 12px;
    flex-wrap: wrap;
  }
  .mi-stat-card {
    background: rgba(255,255,255,.32);
    border: 1px solid rgba(0,110,105,.22);
    border-radius: 10px;
    padding: 12px 16px;
    min-width: 140px;
  }
  .mi-stat-value {
    font-size: 22px;
    font-weight: 700;
    color: #005e5a;
    line-height: 1.2;
  }
  .mi-stat-label {
    font-size: 11px;
    color: #2a7070;
    text-transform: uppercase;
    letter-spacing: .03em;
    font-weight: 600;
  }
  .mi-progress-bar {
    height: 6px;
    background: rgba(0,110,105,.15);
    border-radius: 3px;
    overflow: hidden;
    width: 100%;
  }
  .mi-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #00968c, #00c4b8);
    border-radius: 3px;
  }
`

const PARTICLES = Array.from({ length: 18 }, (_, i) => ({
  id: i,
  size: Math.random() * 4 + 2,
  left: Math.random() * 100,
  dur: Math.random() * 12 + 8,
  delay: Math.random() * 10,
  dx: (Math.random() - 0.5) * 100,
}))

const personalDetailsData = {
  name: "Dipanita Das", code: "E226", firstName: "Dipanita", middleName: "",
  lastName: "Das", fullName: "Dipanita Das", dob: "12/03/2000", gender: "Female",
  bloodGroup: "B+", religion: "Hindu", mobile: "8585858585", alternateMobile: "8558588585",
  email: "dipanita.das@email.com", aadhaar: "8555 8555 8555", pan: "ABCDE6666F",
  pfNumber: "PF/12345/6789", uan: "5854752", bankAccount: "12345678901",
  voterId: "ABC1234567", passport: "65363", password: "••••••••",
  altBankAccount: "98765432101", guardianName: "Rajib Das", relation: "Father",
  altBankIfsc: "SBIN0001234", adaEmail: "Dipanita.Das@adasoftware.com",
  adaSkype: "Dipanita.Das", adaGmail: "Dipanita.Das.ada@gmail.com", altBankType: "Savings"
}

const contactDetailsData = {
  presentAddress: "123 Park Street, Kolkata - 700016", presentCity: "Kolkata",
  presentState: "West Bengal", presentPincode: "700016",
  permanentAddress: "456 Village Road, District - 24 Parganas", permanentCity: "Barasat",
  permanentState: "West Bengal", permanentPincode: "700124",
  emergencyName: "Rajib Das (Father)", emergencyNumber: "9876543210", relationship: "Father",
  altEmergencyName: "Soma Das (Mother)", altEmergencyNumber: "9876543211",
  personalEmail: "dipanita.das.personal@gmail.com", workPhone: "+91 33 1234 5678 (Ext. 226)",
  linkedin: "linkedin.com/in/dipanita-das", github: "github.com/dipanita-das"
}

const leaveStatusData = {
  stats: { totalDays: 18, taken: 12, remaining: 6 },
  leaveTypes: ['Annual Leave', 'Sick Leave', 'Casual Leave', 'Maternity Leave'],
  statuses: ['Approved', 'Pending', 'Rejected'],
  records: [
    { type: 'Annual Leave', fromDate: '2024-11-15', toDate: '2024-11-20', days: 6, status: 'Approved' },
    { type: 'Sick Leave',   fromDate: '2024-08-05', toDate: '2024-08-07', days: 3, status: 'Approved' },
    { type: 'Casual Leave', fromDate: '2024-03-10', toDate: '2024-03-12', days: 3, status: 'Approved' }
  ]
}

const daysAttendedData = {
  stats: { attendanceRate: 87, daysPresent: 142, daysAbsent: 21, totalDays: 163 },
  months: ['January 2024','February 2024','March 2024','April 2024','May 2024','June 2024',
           'July 2024','August 2024','September 2024','October 2024','November 2024'],
  records: [
    { month: 'November 2024', attended: 18, absent: 2, working: 20, overtime: 8.5,  percentage: 90 },
    { month: 'October 2024',  attended: 21, absent: 2, working: 23, overtime: 12.0, percentage: 91 },
    { month: 'September 2024',attended: 20, absent: 2, working: 22, overtime: 6.5,  percentage: 91 }
  ]
}

interface ColSectionState { open: boolean }
interface ColSectionProps { title: string; defaultOpen?: boolean; children?: React.ReactNode }

class CollapsibleSection extends React.Component<ColSectionProps, ColSectionState> {
  constructor(props: ColSectionProps) {
    super(props)
    this.state = { open: props.defaultOpen ?? false }
  }
  toggle = () => this.setState(s => ({ open: !s.open }))
  render() {
    const { title, children } = this.props
    const { open } = this.state
    return (
      <div className="mi-section">
        <div className="mi-shimmer-line" />
        <div className="mi-section-header" onClick={this.toggle}>
          <span className="mi-section-title">{title}</span>
          <span className="mi-toggle-btn">{open ? '−' : '+'}</span>
        </div>
        {open && <div className="mi-section-body">{children}</div>}
      </div>
    )
  }
}

interface FieldProps {
  label: string; value?: string; width?: string; type?: string;
  verified?: boolean; isSelect?: boolean; options?: string[]
}

function Field({ label, value = '', width = 'auto', type = 'text', verified, isSelect, options = [] }: FieldProps) {
  return (
    <div className="mi-field" style={{ width }}>
      <label className="mi-label">{label}</label>
      <div className="mi-input-wrap">
        {isSelect ? (
          <select className="mi-input" defaultValue={value}>
            {options.map(o => <option key={o}>{o}</option>)}
          </select>
        ) : (
          <input className="mi-input" type={type} defaultValue={value} />
        )}
        {verified && <span className="mi-check">✓</span>}
      </div>
    </div>
  )
}

function Row({ children }: { children: React.ReactNode }) {
  return <div className="mi-row">{children}</div>
}

export default class MyInformationPage extends PureComponent {
  render() {
    return (
      <>
        <style>{globalStyles}</style>
        <div className="mi-page">

          <div style={{
            position:'fixed', top:'5%', left:'8%', width:420, height:420, borderRadius:'50%',
            background:'radial-gradient(circle, rgba(0,160,155,.2) 0%, transparent 68%)',
            animation:'orbPulse1 11s ease-in-out infinite', pointerEvents:'none', zIndex:0,
          }} />
          <div style={{
            position:'fixed', bottom:'8%', right:'6%', width:500, height:500, borderRadius:'50%',
            background:'radial-gradient(circle, rgba(0,120,175,.15) 0%, transparent 68%)',
            animation:'orbPulse2 15s ease-in-out infinite', pointerEvents:'none', zIndex:0,
          }} />

          <div className="mi-grid-bg" />

          {PARTICLES.map(p => (
            <div key={p.id} className="mi-particle" style={{
              width:p.size, height:p.size, left:`${p.left}%`, bottom:-p.size,
              ['--dur' as any]:`${p.dur}s`, ['--delay' as any]:`${p.delay}s`, ['--dx' as any]:`${p.dx}px`,
            }} />
          ))}

          <div className="mi-breadcrumb">
            <span className="mi-breadcrumb-current">👤 My Information</span>
          </div>

          <div className="mi-content">

            {/* Personal Details */}
            <div className="mi-section">
              <div className="mi-shimmer-line" />
              <div className="mi-section-header" style={{ cursor:'default' }}>
                <span className="mi-section-title">Personal Details — {personalDetailsData.name}</span>
                <span className="mi-toggle-btn">−</span>
              </div>
              <div className="mi-section-body">
                <Row>
                  <Field label="Code"        value={personalDetailsData.code}       width="20%" verified />
                  <Field label="First Name"  value={personalDetailsData.firstName}  width="22%" verified />
                  <Field label="Middle Name" value={personalDetailsData.middleName} width="22%" />
                  <Field label="Last Name"   value={personalDetailsData.lastName}   width="22%" verified />
                </Row>
                <Row>
                  <div style={{ width:'20%' }} />
                  <Field label="Name"          value={personalDetailsData.fullName}    width="22%" />
                  <Field label="Date of Birth" value={personalDetailsData.dob}        width="13%" type="date" />
                  <Field label="Gender"        value={personalDetailsData.gender}     width="13%" isSelect options={['Female','Male','Other']} />
                  <Field label="Blood Group"   value={personalDetailsData.bloodGroup} width="9%"  isSelect options={['B+','A+','O+','AB+']} />
                  <Field label="Religion"      value={personalDetailsData.religion}   width="11%" />
                </Row>
                <Row>
                  <Field label="Mobile Number"       value={personalDetailsData.mobile}          width="20%" verified />
                  <Field label="Alternate Number"    value={personalDetailsData.alternateMobile} width="22%" />
                  <Field label="Email Id"            value={personalDetailsData.email}           width="28%" />
                  <Field label="Aadhaar Card Number" value={personalDetailsData.aadhaar}         width="22%" />
                </Row>
                <Row>
                  <Field label="PAN"               value={personalDetailsData.pan}         width="20%" />
                  <Field label="PF Account Number" value={personalDetailsData.pfNumber}    width="22%" />
                  <Field label="UAN"               value={personalDetailsData.uan}         width="22%" />
                  <Field label="Bank Account Number For Salary Transfer" value={personalDetailsData.bankAccount} width="28%" />
                </Row>
                <Row>
                  <Field label="Voter ID"        value={personalDetailsData.voterId}       width="20%" />
                  <Field label="Passport Number" value={personalDetailsData.passport}      width="22%" />
                  <Field label="My Password"     value={personalDetailsData.password}      width="22%" type="password" />
                  <Field label="Alternative Bank Account Number" value={personalDetailsData.altBankAccount} width="28%" />
                </Row>
                <Row>
                  <Field label="Guardian Name" value={personalDetailsData.guardianName} width="44%" />
                  <Field label="Relation"      value={personalDetailsData.relation}     width="22%" />
                  <Field label="Alternate Bank Account IFSC" value={personalDetailsData.altBankIfsc} width="28%" />
                </Row>
                <Row>
                  <Field label="ADA Software Email ID"      value={personalDetailsData.adaEmail}   width="26%" />
                  <Field label="ADA Software Skype ID"      value={personalDetailsData.adaSkype}   width="22%" />
                  <Field label="ADA Software Gmail ID"      value={personalDetailsData.adaGmail}   width="26%" />
                  <Field label="Alternate Bank Account Type" value={personalDetailsData.altBankType} width="18%" isSelect options={['Savings','Current']} />
                </Row>
              </div>
            </div>

            {/* Contact Details */}
            <CollapsibleSection title="Contact Details" defaultOpen={true}>
              <Row>
                <Field label="Present Address" value={contactDetailsData.presentAddress} width="48%" />
                <Field label="City"    value={contactDetailsData.presentCity}    width="15%" />
                <Field label="State"   value={contactDetailsData.presentState}   width="15%" />
                <Field label="Pincode" value={contactDetailsData.presentPincode} width="12%" />
              </Row>
              <Row>
                <Field label="Permanent Address" value={contactDetailsData.permanentAddress} width="48%" />
                <Field label="City"    value={contactDetailsData.permanentCity}    width="15%" />
                <Field label="State"   value={contactDetailsData.permanentState}   width="15%" />
                <Field label="Pincode" value={contactDetailsData.permanentPincode} width="12%" />
              </Row>
              <Row>
                <Field label="Emergency Contact Name"      value={contactDetailsData.emergencyName}      width="25%" verified />
                <Field label="Emergency Contact Number"    value={contactDetailsData.emergencyNumber}    width="20%" verified />
                <Field label="Relationship"                value={contactDetailsData.relationship}       width="15%" />
                <Field label="Alternate Emergency Contact" value={contactDetailsData.altEmergencyName}   width="25%" />
                <Field label="Alternate Phone"             value={contactDetailsData.altEmergencyNumber} width="15%" />
              </Row>
              <Row>
                <Field label="Personal Email"         value={contactDetailsData.personalEmail} width="30%" />
                <Field label="Work Phone (Extension)" value={contactDetailsData.workPhone}     width="25%" />
                <Field label="LinkedIn Profile"       value={contactDetailsData.linkedin}      width="25%" />
                <Field label="GitHub"                 value={contactDetailsData.github}        width="20%" />
              </Row>
            </CollapsibleSection>

            {/* Leave Status */}
            <CollapsibleSection title="Leave Status" defaultOpen={true}>
              <Row>
                <div className="mi-attendance-stats">
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{leaveStatusData.stats.totalDays}</div>
                    <div className="mi-stat-label">Total Leave Days (2024)</div>
                  </div>
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{leaveStatusData.stats.taken}</div>
                    <div className="mi-stat-label">Leaves Taken</div>
                  </div>
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{leaveStatusData.stats.remaining}</div>
                    <div className="mi-stat-label">Remaining</div>
                  </div>
                </div>
              </Row>
              {leaveStatusData.records.map((record, index) => (
                <Row key={index}>
                  <Field label="Leave Type" value={record.type}            width="20%" isSelect options={leaveStatusData.leaveTypes} />
                  <Field label="From Date"  value={record.fromDate}        width="15%" type="date" />
                  <Field label="To Date"    value={record.toDate}          width="15%" type="date" />
                  <Field label="Days"       value={record.days.toString()} width="8%" />
                  <Field label="Status"     value={record.status}          width="12%" isSelect options={leaveStatusData.statuses} />
                  <span className="mi-leave-badge">✓ {record.status}</span>
                </Row>
              ))}
            </CollapsibleSection>

            {/* Days Attended */}
            <CollapsibleSection title="Days Attended" defaultOpen={true}>
              <Row>
                <div className="mi-attendance-stats">
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{daysAttendedData.stats.attendanceRate}%</div>
                    <div className="mi-stat-label">Attendance Rate</div>
                    <div className="mi-progress-bar" style={{ marginTop:'8px' }}>
                      <div className="mi-progress-fill" style={{ width:`${daysAttendedData.stats.attendanceRate}%` }} />
                    </div>
                  </div>
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{daysAttendedData.stats.daysPresent}</div>
                    <div className="mi-stat-label">Days Present</div>
                  </div>
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{daysAttendedData.stats.daysAbsent}</div>
                    <div className="mi-stat-label">Days Absent</div>
                  </div>
                  <div className="mi-stat-card">
                    <div className="mi-stat-value">{daysAttendedData.stats.totalDays}</div>
                    <div className="mi-stat-label">Total Working Days</div>
                  </div>
                </div>
              </Row>
              {daysAttendedData.records.map((record, index) => (
                <Row key={index}>
                  <Field label="Month"          value={record.month}               width="20%" isSelect options={daysAttendedData.months} />
                  <Field label="Days Attended"  value={record.attended.toString()} width="12%" />
                  <Field label="Days Absent"    value={record.absent.toString()}   width="12%" />
                  <Field label="Working Days"   value={record.working.toString()}  width="12%" />
                  <Field label="Overtime Hours" value={record.overtime.toString()} width="12%" />
                  <span className="mi-leave-badge">{record.percentage}% Attendance</span>
                </Row>
              ))}
            </CollapsibleSection>

          </div>
        </div>
      </>
    )
  }
}